import Search from '../../components/SearchFilter'
import Table from '../../components/TableAntd'
import CustomModal from '../../components/ModalUser'
import { Button } from 'antd'
import Buttonbar from '../../components/ButtonBar'
import useaccounthooks from './hooks'

const Account = () => {
  const {
    dataSource,
    visible,
    pages,
    onSearch,
    onChange,
    onRefresh,
    deleteuser,
    visiblemodal,
    onChangeCheck,
    addMember,
    moveAdmin,
    rolevisible,
    rolevisiblemodal,
    confirmMoveAdmin,
  } = useaccounthooks()

  const listColumn = [
    {
      key: 'realName',
      title: '姓名',
    },
    {
      key: 'mobile',
      title: '手机号码',
    },
    {
      key: 'mail',
      title: '邮箱',
    },
    {
      key: 'role',
      title: '账号类型',
    },
  ]

  return (
    <div>
      <Search
        keyName="REGISTERSUPPLIERACCOUNT"
        fieldsData={['realName', 'mobile', 'mail']}
        onSearch={onSearch}
        ScreenKey="REGISTERSUPPLIERACCOUNT"
      />
      <div style={{ padding: '0 10px' }}>
        {/* 操作栏 */}
        <Buttonbar onRefresh={onRefresh}>
          <Button type="link" size="small" onClick={() => addMember()}>
            新增
          </Button>
          <Button type="link" size="small" onClick={() => moveAdmin()}>
            移交管理员
          </Button>
          <Button danger type="link" size="small" onClick={deleteuser}>
            删除
          </Button>
        </Buttonbar>
        <Table
          loading={dataSource.loading}
          dataSource={dataSource.data}
          listColumn={listColumn}
          showSort
          onChangeCheck={onChangeCheck}
          pagination={{
            total: dataSource.total,
            current: pages.pageNo,
            pagesize: pages.pagesize,
            onChange: onChange,
          }}
        />
      </div>
      <CustomModal
        open={visible}
        width={400}
        title="提示窗"
        okText="确认移交"
        modalSubmit={confirmMoveAdmin}
        modalCancel={visiblemodal}
      >
        <div style={{ padding: '30px 10px' }}>
          移交管理员后，将无法管理该供应商的账号数据，是否确认移交？
        </div>
      </CustomModal>

      <CustomModal
        open={rolevisible}
        width={300}
        title="提示窗"
        modalCancel={rolevisiblemodal}
        modalSubmit={rolevisiblemodal}
      >
        <div style={{ padding: '30px 10px' }}>只能选择一个对象进行移交</div>
      </CustomModal>
    </div>
  )
}

export default Account
import Search from '../../components/SearchFilter'
import Table from '../../components/TableAntd'
import CustomModal from '../../components/ModalUser'
import { Button } from 'antd'
import Buttonbar from '../../components/ButtonBar'
import useaccounthooks from './hooks'

const Account = () => {
  const {
    dataSource,
    visible,
    pages,
    onSearch,
    onChange,
    onRefresh,
    deleteuser,
    visiblemodal,
    onChangeCheck,
    addMember,
    moveAdmin,
    rolevisible,
    rolevisiblemodal,
    confirmMoveAdmin,
  } = useaccounthooks()

  const listColumn = [
    {
      key: 'realName',
      title: '姓名',
    },
    {
      key: 'mobile',
      title: '手机号码',
    },
    {
      key: 'mail',
      title: '邮箱',
    },
    {
      key: 'role',
      title: '账号类型',
    },
  ]

  return (
    <div>
      <Search
        keyName="REGISTERSUPPLIERACCOUNT"
        fieldsData={['realName', 'mobile', 'mail']}
        onSearch={onSearch}
        ScreenKey="REGISTERSUPPLIERACCOUNT"
      />
      <div style={{ padding: '0 10px' }}>
        {/* 操作栏 */}
        <Buttonbar onRefresh={onRefresh}>
          <Button type="link" size="small" onClick={() => addMember()}>
            新增
          </Button>
          <Button type="link" size="small" onClick={() => moveAdmin()}>
            移交管理员
          </Button>
          <Button danger type="link" size="small" onClick={deleteuser}>
            删除
          </Button>
        </Buttonbar>
        <Table
          loading={dataSource.loading}
          dataSource={dataSource.data}
          listColumn={listColumn}
          showSort
          onChangeCheck={onChangeCheck}
          pagination={{
            total: dataSource.total,
            current: pages.pageNo,
            pagesize: pages.pagesize,
            onChange: onChange,
          }}
        />
      </div>
      <CustomModal
        open={visible}
        width={400}
        title="提示窗"
        okText="确认移交"
        modalSubmit={confirmMoveAdmin}
        modalCancel={visiblemodal}
      >
        <div style={{ padding: '30px 10px' }}>
          移交管理员后，将无法管理该供应商的账号数据，是否确认移交？
        </div>
      </CustomModal>

      <CustomModal
        open={rolevisible}
        width={300}
        title="提示窗"
        modalCancel={rolevisiblemodal}
        modalSubmit={rolevisiblemodal}
      >
        <div style={{ padding: '30px 10px' }}>只能选择一个对象进行移交</div>
      </CustomModal>
    </div>
  )
}

export default Account
